<template>
  <div>
    <custom-dialog
      :visible.sync="open"
      :options="dialogOptions"
      ref="yxqnPrompt"
      width="520px">
      <div class="remark-approval-suc-box">
        <textarea
          :maxlength="maxlength"
          v-model="textArea"
          :placeholder="placeholder"
          class="remark-approval-suc"
          style="resize: none"
        >
        </textarea>
        <div class="remark-approval-suc-actions">
          <div class="cancel-remark" @click="cancel()">{{cancelBtnText}}</div>
          <div class="confirm-remark" @click="confirm()">{{confirmBtnText}}</div>
        </div>
      </div>
    </custom-dialog>
  </div>
</template>

<script>

export default {
  name: 'yxqnPrompt',
  data () {
    return {
      open: false,
      dialogOptions: {
        coverClose: true,
        titleHeight: 44,
        titleFontSize: 18
      },
      placeholder: '请备注用户需要注意的相关信息（非必填）',
      textArea: '',
      maxlength: 50,
      confirmBtnText: '确认',
      cancelBtnText: '取消',
      errorMessage: '输入内容不符合要求'
    }
  },
  methods: {
    show (config) {
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    confirm () {
      const inputPattern = this.pattern
      if (inputPattern && !inputPattern.test(this.textArea || '')) {
        this.$message.warning(this.errorMessage)
        return false
      }
      const validator = this.validator
      if (typeof validator === 'function') {
        this.validator(this.textArea, (err) => {
          if (err) {
            this.$message.warning(err)
            return
          }
          this.resolve(this.textArea)
          this.hide()
        })
        return false
      }
      this.resolve(this.textArea)
      this.hide()
    },
    cancel () {
      this.reject('')
      this.hide()
    },
    hide () {
      this.open = false
      // document.body.removeChild(this.$el)
      // this.refs.yxqnPrompt.hide()
      // this.$destroy()
    }
  }
}
</script>

<style scoped lang="less">
  @import "../../styles/customMixin.less";

  .remark-approval-suc-box {
    .flex-column-normal();
    align-items: center;
    padding-bottom: 40px;
    .remark-approval-suc-actions {
      .flexMixin();
      margin-top: 40px;

      .confirm-remark {
        .yxqn-btn-primary();
      }

      .cancel-remark {
        .yxqn-btn-cancel();
        margin-right: 20px;
      }
    }
  }

  .remark-approval-suc {
    margin-top: 42px;
    width: 440px;
    height: 130px;
    box-sizing: border-box;
    border: 1px solid @border-color;
    border-radius: 3px;
    background: @body-bgc;
    padding: 13px 15px;
    font-size: 14px;
    color: @text-primary-color;
    outline: none;

    &:focus {
      outline: none;
      border: 1px solid @color-blue;
    }
  }
</style>
